import { autoinject, transient, computedFrom } from "aurelia-framework";
import { TabModel } from "@rightship-tech/common-ui/models/basic.models";
import { PartialRightshipInspectionCustomerFindings } from "../../partials/customer-findings/partial-rightship-inspection-customer-findings";
import { PartialRightshipInspectionReport } from "../../partials/inspection-report/partial-rightship-inspection-report";
import { AttachmentViewerExecutionModel } from "@rightship-tech/common-ui/models/attachments.models";
import { InsightIndicatorModel } from "../../../models/rightship-inspection.models";

@autoinject
@transient()
export class InspectionReportTabs {
    public rightShipInspectionId: number;
    public validUntil: string;
    public validUntilText: string;
    public statusName: string;
    public statusId: number;
    public summary: string;
    public formHasBeenSubmitted: boolean;
    public tabs: TabModel[];
    public hideShareButton: boolean;
    private _currentTab: TabModel;
    private _rightshipInspectionCustomerId: number;
    public toggleInspectionDetailDrawer: (model: AttachmentViewerExecutionModel) => void;
    public showInspectionDetailsDrawer: boolean;
    public item: {
        rightShipInspectionId: number,
        formHasBeenSubmitted: boolean,
        questionNumber?: string,
        hasInspectionOutcomeV2?: boolean
    }
    attachmentViewerExecutionModel: AttachmentViewerExecutionModel;
    public closeoutType: string;
    constructor( private partialRightshipInspectionCustomerFindings: PartialRightshipInspectionCustomerFindings,
        private partialRightshipInspectionReport: PartialRightshipInspectionReport
    ) {
    }

    async activate(model: { inspectionId: number, validUntil: string, validUntilText: string, hideShareButton: boolean, insightIndicators: InsightIndicatorModel[],
        preview: boolean, additionalCommentsForDurationOfValidity: string, statusName: string, statusId: number, summary: string, formHasBeenSubmitted: boolean, hasInspectionOutcomeV2: boolean,
        reasonForDurationOfValidity: string, customerId: number, toggleInspectionDetailDrawer: (model: AttachmentViewerExecutionModel) => void, closeoutType: string }) {
        
        this.rightShipInspectionId = model.inspectionId;
        this.validUntil = model.validUntil;
        this.validUntilText = model.validUntilText;
        this.statusName = model.statusName;
        this.statusId = model.statusId;
        this.summary = model.summary;
        this.formHasBeenSubmitted = model.formHasBeenSubmitted;
        this.hideShareButton = model.hideShareButton;
        this._rightshipInspectionCustomerId = model.customerId;
        this.toggleInspectionDetailDrawer = model.toggleInspectionDetailDrawer
        this.item = {
            rightShipInspectionId: this.rightShipInspectionId,
            formHasBeenSubmitted: this.formHasBeenSubmitted,
            hasInspectionOutcomeV2: model.hasInspectionOutcomeV2
        };
        this.closeoutType = model.closeoutType;
        this.tabs = [
            {
                title: "Outcome",
                step: 1,
                show: true,
                vm: this.partialRightshipInspectionReport,
                getModel: () => {
                    return {
                        viewInDialog: false,
                        inspectionId: this.rightShipInspectionId,
                        validUntilText: this.validUntilText,
                        validUntil: this.validUntil,
                        summary: this.summary,
                        statusName: this.statusName,
                        statusId: this.statusId,
                        customerId: this._rightshipInspectionCustomerId,
                        hideShareButton: this.hideShareButton,
                        preview: model.preview,
                        insightIndicators: model.insightIndicators,
                        openFindings: this.openFindingsTab.bind(this),
                        closeoutType: this.closeoutType
                    }
                }
            },
            {
                title: "Findings",
                step: 2,
                show: true,
                vm: this.partialRightshipInspectionCustomerFindings,
                getModel: () => {
                    return {
                        item: this.item,
                        toggleInspectionDetailDrawer: this.toggleInspectionDetailsDrawer.bind(this)
                    }
                }
            }
        ];
    }

    toggleInspectionDetailsDrawer(model: AttachmentViewerExecutionModel) {
        this.attachmentViewerExecutionModel = model;
        this.showInspectionDetailsDrawer = !this.showInspectionDetailsDrawer;
    }

    tabChanged(event:any){
        this._currentTab = null;
        const step = event.detail.step;

        setTimeout(() => {
            const tab = this.tabs.filter(x=>x.step == step)[0];
            this._currentTab = tab
        });
    }

    openFindingsTab(questionNumber: string) {
        const findingsTab = this.tabs.find(x => x.title == "Findings");
        this.item.questionNumber = questionNumber ? questionNumber: null;
        if(findingsTab) {
            this.tabChanged({detail: {step: findingsTab.step}});
        }
    }

    @computedFrom("_currentTab")
    get currentTab(){
        return this._currentTab;
    }

    set currentTab(value) {
    }
}